// Basic
import PropTypes from 'prop-types';
// Common
import EXTERNAL_CONTRACT_TYPES from '../../../../../enums/externalContractType';
// Components
import { ModalBody } from '@/common-utils/components/ui/modal';
import AddAlmaApiKeyForm from './AddAlmaApiKeyForm';
import AddVadContractForm from './AddVadContractForm';

/**
 * @param {function} setValidForm
 * @param {function} setFormData
 * @param {object} selectedExtContract
 * @returns {JSX} BodyAddContractForm
 */
function BodyAddContractForm({ setValidForm, setFormData, selectedExtContract }) {
    return (
        <ModalBody>
            {selectedExtContract.type.name === EXTERNAL_CONTRACT_TYPES.ALMA.name
                && <AddAlmaApiKeyForm setValidForm={setValidForm} setFormData={setFormData} />}
            {selectedExtContract.type.name === EXTERNAL_CONTRACT_TYPES.VAD.name
                && <AddVadContractForm setValidForm={setValidForm} setFormData={setFormData} />
            }
        </ModalBody>
    );
}

BodyAddContractForm.propTypes = {
    setValidForm: PropTypes.func,
    setFormData: PropTypes.func,
    selectedExtContract: PropTypes.object
};

export default BodyAddContractForm;